import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  MessageCircle,
  MessagesSquare,
  ClipboardList,
  X
} from "lucide-react";

const VentureSidebar = ({ sidebarOpen, setSidebarOpen }) => {

  const closeSidebar = () => {
    if (window.innerWidth < 992) {
      setSidebarOpen(false);
    }
  };

  return (
    <>

      {sidebarOpen && (
        <div
          className="venture-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div
        className={`venture-sidebar ${sidebarOpen ? "open" : ""}`}
      >

        <div className="venture-sidebar-header">

          <h3>Venture</h3>

          <button
            className="venture-close"
            onClick={() => setSidebarOpen(false)}
          >
            <X size={20} />
          </button>

        </div>

        <NavLink
          exact
          to="/venture"
          activeClassName="active"
          onClick={closeSidebar}
        >
          <LayoutDashboard size={18} />
          Dashboard
        </NavLink>

        <NavLink
          exact
          to="/venture/conversations"
          activeClassName="active"
          onClick={closeSidebar}
        >
          <MessageCircle size={18} />
          Conversations
        </NavLink>

        <NavLink
          exact
          to="/venture/chat-selection"
          activeClassName="active"
          onClick={closeSidebar}
        >
          <MessagesSquare size={18} />
          Chat Selection
        </NavLink>

        <NavLink
          exact
          to="/venture/feedback"
          activeClassName="active"
          onClick={closeSidebar}
        >
          <ClipboardList size={18} />
          Feedback
        </NavLink>

      </div>

    </>
  );
};

export default VentureSidebar;